export const withoutProtocol = (url: string) => url.replace(/^\s*https?:\/\//, "");
